import { render, staticRenderFns } from "./filesView.vue?vue&type=template&id=2811fe42&"
import script from "./filesView.vue?vue&type=script&lang=js&"
export * from "./filesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports